import { Alert, Link, Stack, Typography } from "@mui/material";
import { Flex, colors } from "@zfp-akademie-a-s/zfp-design";
import { ReportIssueFAQ } from "Components/ReportIssue/ReportIssueFAQ";
import { AuthenticatedLayout } from "Components/_Shared/Layouts/AuthenticatedLayout";
import { ANALYZER_EMAIL } from "Infrastructure/Config/constants";
import { Radius, Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";

export const ReportIssuePage = () => {
  const { t } = useResource();

  return (
    <AuthenticatedLayout
      title={t(Resources.ReportIssue.Title)}
      header={{ title: t(Resources.ReportIssue.Title), subtitle: t(Resources.ReportIssue.SubTitle) }}
    >
      <Stack spacing={Spacing.XXXL}>
        <ReportIssueFAQ />
        <Typography variant="subtitle1" fontWeight={600}>
          {t(Resources.ReportIssue.Feedback.Prompt)}
        </Typography>
        <Flex width="100%">
          <Stack
            width="70%"
            alignItems="center"
            textAlign="center"
            spacing={Spacing.M}
            p={Spacing.XXL}
            borderRadius={Radius.M}
            border="1px solid"
            borderColor="divider"
            bgcolor={colors.backgroundLight}
          >
            <Typography variant="body2">{`${t(Resources.ReportIssue.Feedback.SendEmailTo)}:`}</Typography>
            <Link href={`mailto:${ANALYZER_EMAIL}`} underline="hover" color="text.primary">
              <Typography variant="h2" fontWeight={600} color="inherit">
                {ANALYZER_EMAIL}
              </Typography>
            </Link>
            <Alert severity="info">{t(Resources.ReportIssue.Feedback.NotForIssues)}</Alert>
          </Stack>
        </Flex>
      </Stack>
    </AuthenticatedLayout>
  );
};
